import { useFormikContext, useField } from "formik";
import React, { useState } from "react";
import { Dimensions } from "react-native";
import DropDownPicker from "react-native-dropdown-picker";
import {
  responsiveHeight,
  responsiveFontSize,
} from "react-native-responsive-dimensions";
const windowHeight = Dimensions.get('window').height;
const DropDownFormik = ({ open, setOpen, ...props }) => {
  const [openProvider, setOpenProvider] = useState(false);
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  const isControlled = typeof open === "boolean" && typeof setOpen === "function";
  const pickerOpen = isControlled ? open : openProvider;
  const pickerSetOpen = isControlled ? setOpen : setOpenProvider;

  return (
    <DropDownPicker
      {...field}
      {...props}
      open={pickerOpen}
      setOpen={pickerSetOpen}
      value={field.value}
      setValue={(val) => setFieldValue(field.name, val())}

      searchPlaceholder=" এখানে সার্চ করুন.. 🔍"
      placeholderStyle={{
        color: "#999898",
        fontSize: 14,
        fontFamily: "SolaimanLipi",
      }}

      style={{
        ...props.style,
        minHeight: responsiveHeight(4.1),
        borderRadius: 1,
        borderWidth: 1,
        paddingHorizontal: 5,
        backgroundColor: "#FFF",
        borderColor: "#000",
        padding: 5,
        fontSize: 14
       
      }}

      textStyle={{
        fontSize: 14,
        fontFamily: "SolaimanLipi",
        lineHeight: 16,
        color: "#222",
      }}

      dropDownContainerStyle={{
        borderWidth: 1,
        borderColor: "#000",
        borderRadius: 4,
        maxHeight: windowHeight -160,
        width: "auto",
        marginTop: 5,
      
      }}

      listItemContainerStyle={{
        minHeight: 20,
        paddingHorizontal: 5,
        borderBottomWidth: 1,
        borderBottomColor: "#acacac",
        // height: 35,
        paddingBottom: 2

       
      }}

      listItemLabelStyle={{
        fontSize: 14,
        fontFamily: "SolaimanLipi",
        color: "#333",
        lineHeight: 16,
        width: "auto",
        minWidth: 270,
        // minHeight: 20,
        // height: 35,
        paddingTop: 10
      }}

      selectedItemContainerStyle={{
        backgroundColor: "#f8f8f8",
      }}

      selectedItemLabelStyle={{
        fontSize: 14,
        fontFamily: "SolaimanLipi",
        color: "#000",
      }}

      customItemLabelStyle={{
        fontSize: 14,
        fontFamily: "SolaimanLipi",

      }}

      searchTextInputStyle={{
        borderWidth: 1,
        borderColor: "#ddd",
        fontSize: 12,
        minHeight: 36,
        fontFamily: "SolaimanLipi",
      }}
    />
  );
};

export default DropDownFormik;
